import React from 'react';
import { Jest, GlobalLayout } from '../';

const JestPage = (props) => (
  <GlobalLayout>
    <Jest {...props} />
  </GlobalLayout>
);

export default JestPage;